// Copy de la landing page publique (app/(root)/), centralisé ici pour
// pouvoir itérer sur le texte (corrections, A/B test) sans toucher au JSX.
// Cf. doc/api.md et brief marketing — Proposition A.

export const nav = {
  monEspace: "Mon espace",
  seConnecter: "Se connecter",
  creerCompte: "Créer un compte",
};

export const hero = {
  badge: "STI2D · STMG · ST2S · STL · 100% gratuit",
  titleLine1: "Tu n'es pas nul·le en cours.",
  titleLine2: "On t'a juste jamais donné les bons outils.",
  subtitle:
    "La première appli de révision pensée pour les filières technologiques — et pour les cerveaux qui n'apprennent pas comme dans les manuels. Cours structurés, flashcards qui s'adaptent à ta mémoire, entraînement bac ciblé.",
  ctaAnonyme: "Je crée mon compte gratuit",
  ctaConnecte: "Accéder à l'app",
  reassurance: "Gratuit, sans carte bancaire. 2 minutes montre en main.",
};

export const statsIntro = "Pas des promesses en l'air :";

// Chiffres arrondis au-dessous des compteurs réels en base (vérifiés le
// 1er septembre 2026 : 210 notions, 2115 mots, 660 questions de bac) — garde
// une marge pour que le "+" reste vrai le temps que le contenu continue de
// grandir, sans avoir à retoucher ces valeurs à chaque ajout de fiche.
export const stats = [
  { icon: "ti-books", value: "200+", label: "notions de cours" },
  { icon: "ti-key", value: "2100+", label: "mots de vocabulaire" },
  { icon: "ti-target-arrow", value: "650+", label: "questions de bac" },
  { icon: "ti-brain", value: "SM-2", label: "mémorisation prouvée" },
];

export const probleme = {
  label: "Le constat",
  title: "Réviser, c'est censé être simple. Sauf que…",
  items: [
    "Les fiches de révision qui existent sont faites pour la filière générale — jamais pour toi.",
    "Les applis de flashcards généralistes ne couvrent ni le Droit, ni le Management, ni les projets de STI2D.",
    "Si t'es dyslexique, dyspraxique ou juste \"pas fait pour la lecture\", personne n'a pensé le contenu pour toi.",
    "Résultat : tu révises quand même, mais tu as l'impression de perdre ton temps.",
  ],
};

export const comment = {
  label: "Comment ça marche",
  title: "De la première lecture au bac",
  subtitle: "Une méthode en trois temps qui suit ta progression naturelle.",
};

export const steps = [
  {
    icon: "ti-book-2",
    num: "01",
    title: "Lis la notion",
    desc: "Chaque notion est découpée en parties claires : idée centrale, exemples concrets, méthode et repères pour éviter les erreurs classiques.",
  },
  {
    icon: "ti-help-circle",
    num: "02",
    title: "Teste tes connaissances",
    desc: "Un QCM à la fin de chaque partie. Correction immédiate avec explication pour comprendre, pas juste mémoriser.",
  },
  {
    icon: "ti-cards",
    num: "03",
    title: "Révise avec les flashcards",
    desc: "L'algorithme SM-2 calcule exactement quand revoir chaque mot clé. Tu révises moins, tu retiens plus longtemps.",
  },
];

export const fonctionnalites = {
  label: "Fonctionnalités",
  title: "Tout ce qu'il faut pour réussir",
  subtitle:
    "Philosophie, mathématiques, et le programme complet de STI2D, STMG, ST2S et STL — un seul espace de révision.",
};

export const features = [
  {
    icon: "ti-accessible",
    title: "Pensé pour tous les cerveaux",
    desc: "Police adaptée à la dyslexie, contrastes conformes aux normes d'accessibilité, pas de chrono qui stresse. Pas une option cachée dans un menu — la base, pour tout le monde.",
    color: "#1D9E75",
  },
  {
    icon: "ti-adjustments-alt",
    title: "Révision adaptive",
    desc: "SM-2 programme tes révisions au bon moment — ni trop tôt, ni trop tard. Prouvé scientifiquement.",
    color: "#7F77DD",
  },
  {
    icon: "ti-trophy",
    title: "Gamification",
    desc: "XP, niveaux, badges et streak quotidien pour rester motivé jusqu'au jour du bac.",
    color: "#f59e0b",
  },
  {
    icon: "ti-device-mobile",
    title: "PWA mobile",
    desc: "Installable sur ton téléphone, fonctionne hors-ligne. Révise dans le bus, entre deux cours.",
    color: "#60a5fa",
  },
  {
    icon: "ti-shield-lock",
    title: "Données souveraines",
    desc: "Hébergé en Europe, zéro tracking publicitaire. Tes données restent tes données.",
    color: "#38bdf8",
  },
  {
    icon: "ti-target-arrow",
    title: "Entraînement bac ciblé",
    desc: "560+ questions tirées des annales, classées par thème et fréquence d'apparition, pour réviser ce qui tombe vraiment.",
    color: "#fb7185",
  },
];

export const faq = {
  label: "FAQ",
  title: "Des questions ? On y répond.",
  items: [
    {
      q: "C'est vraiment gratuit ?",
      a: "Oui. La version gratuite te donne accès à des révisions complètes. Un abonnement premium existe pour ceux qui veulent débloquer tout le contenu, mais tu peux progresser sans jamais payer.",
    },
    {
      q: "Je suis dyslexique / dys, c'est vraiment adapté ou c'est juste marketing ?",
      a: "Police lisible, espacement augmenté, pas de temps limité par défaut, contrastes testés — c'est intégré dès la conception, pas ajouté après. On continue de l'améliorer avec les retours des élèves.",
    },
    {
      q: "Mes données sont où ?",
      a: "Sur une infrastructure hébergée en Europe, qu'on contrôle nous-mêmes. Zéro tracking publicitaire, zéro revente à des tiers.",
    },
    {
      q: "Ça remplace mes cours ?",
      a: "Non — ça complète. LycéoLearn t'aide à retenir ce que tu as vu en classe, pas à l'inventer.",
    },
  ],
};

export const ctaFinal = {
  badge: "Gratuit, sans pub, sans engagement",
  title: "Prêt à réviser sans te sentir largué·e ?",
  subtitle:
    "Crée ton compte en 30 secondes et commence ta première notion ce soir — quelle que soit ta filière.",
  cta: "Je commence gratuitement",
};
